/**
 * Language Switcher Dropdown
 */

const initLanguageSwitcher = () => {
	const toggle = document.querySelector(".js-lang-toggle");
	const dropdown = document.querySelector(".lang-dropdown");

	if (!toggle || !dropdown) return;

	// Toggle dropdown
	toggle.addEventListener("click", (e) => {
		e.preventDefault();
		e.stopPropagation();

		const isOpen = dropdown.classList.contains("is-open");

		// Close all other dropdowns
		document.querySelectorAll(".lang-dropdown.is-open").forEach((dd) => {
			dd.classList.remove("is-open");
		});
		document.querySelectorAll(".lang-toggle.is-active").forEach((tg) => {
			tg.classList.remove("is-active");
		});

		// Toggle current dropdown
		if (!isOpen) {
			dropdown.classList.add("is-open");
			toggle.classList.add("is-active");
		}
	});

	// Close dropdown when clicking outside
	document.addEventListener("click", (e) => {
		if (!toggle.contains(e.target) && !dropdown.contains(e.target)) {
			dropdown.classList.remove("is-open");
			toggle.classList.remove("is-active");
		}
	});

	// Close dropdown on escape key
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape" && dropdown.classList.contains("is-open")) {
			dropdown.classList.remove("is-open");
			toggle.classList.remove("is-active");
			toggle.focus();
		}
	});

	// Handle keyboard navigation
	toggle.addEventListener("keydown", (e) => {
		if (e.key === "Enter" || e.key === " ") {
			e.preventDefault();
			toggle.click();
		}
	});

	// Handle dropdown link clicks
	dropdown.addEventListener("click", (e) => {
		const link = e.target.closest(".lang-dropdown__link");
		if (link) {
			// Close dropdown after a short delay to allow navigation
			setTimeout(() => {
				dropdown.classList.remove("is-open");
				toggle.classList.remove("is-active");
			}, 100);
		}
	});
};

// Initialize when DOM is ready
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initLanguageSwitcher);
} else {
	initLanguageSwitcher();
}

export default initLanguageSwitcher;
